export enum DatabaseType {
MSSQL,
MYSQL,
MARIADB,
}
